import { MutableRefObject } from 'react';
import { OrderId, PartnerId, StoreId } from 'shared/domain';
import { AdoptionStep, DriverInstance } from 'shared/libs/feature-adoption';
import { adoptionAnalytics } from 'shared/libs/feature-adoption/analytics';
import { ORDER_READY_ADOPTION } from '../domain/mainKanbanCard.const';
import { useMainKanbanCardAdoptionLang } from './useMainKanbanCardAdoptionLang';

export function useMainKanbanCardAdoption(params: Params) {
  const { partnerId, storeId, tooltip, orderId } = params;
  const { text, disclaimer } = useMainKanbanCardAdoptionLang();

  const _orderReadyStep: AdoptionStep = {
    element: `#${ORDER_READY_ADOPTION}-${orderId}`,
    popover: {
      title: text.orderReady,
      description: disclaimer.orderReadyDisclaimer,
      side: 'left',
      align: 'start',
      onPopoverRender: (_, opts) => {
        if (opts.config.steps?.length! > 1) {
          tooltip.current?.getActiveElement()?.scrollIntoView(true);
        }
      },
      onNextClick: () => {
        adoptionAnalytics.log({ partnerId, storeId, feature: 'pedido_listo' });
        tooltip.current?.moveNext();
      },
    },
  };

  return {
    step: {
      orderReady: _orderReadyStep,
    },
  };
}

type Params = {
  partnerId: PartnerId;
  storeId: StoreId;
  tooltip: MutableRefObject<DriverInstance | null>;
  orderId: OrderId;
};
